// shellMode.js — Apps / Connect / Workspace shell toggle

export const SHELL_MODE = Object.freeze({
  /** Connected apps / sources (legacy key: simple) */
  SIMPLE: 'simple',
  /** Suggested cross-app connections */
  CONNECT: 'connect',
  /** Full workshop sidebar */
  WORKSHOP: 'workshop',
});

/** Alias for Apps mode — same storage value as SIMPLE */
export const SHELL_MODE_APPS = SHELL_MODE.SIMPLE;

export const SHELL_MODE_STORAGE_KEY = 'orbital.shellMode';

/**
 * True when the left column uses the Simple (Apps/Connect) shell chrome.
 *
 * @param {unknown} mode
 * @returns {boolean}
 */
export function isSimpleShellMode(mode) {
  const cleaned = String(mode || '').trim().toLowerCase();
  return cleaned === SHELL_MODE.SIMPLE || cleaned === SHELL_MODE.CONNECT;
}

/**
 * Normalizes a raw shell mode value.
 *
 * @param {unknown} value
 * @returns {'simple'|'connect'|'workshop'}
 */
export function normalizeShellMode(value) {
  const cleaned = String(value || '').trim().toLowerCase();
  if (cleaned === SHELL_MODE.WORKSHOP) return SHELL_MODE.WORKSHOP;
  if (cleaned === SHELL_MODE.CONNECT) return SHELL_MODE.CONNECT;
  if (cleaned === SHELL_MODE.SIMPLE || cleaned === 'apps') return SHELL_MODE.SIMPLE;
  return SHELL_MODE.WORKSHOP;
}

/**
 * Reads persisted shell mode (defaults to Workspace; Sources now lives in Settings).
 *
 * @returns {'simple'|'connect'|'workshop'}
 */
export function getStoredShellMode() {
  if (typeof window === 'undefined') return SHELL_MODE.WORKSHOP;
  try {
    return normalizeShellMode(window.localStorage.getItem(SHELL_MODE_STORAGE_KEY));
  } catch {
    return SHELL_MODE.WORKSHOP;
  }
}

/**
 * Persists shell mode.
 *
 * @param {unknown} mode
 * @returns {'simple'|'connect'|'workshop'}
 */
export function setStoredShellMode(mode) {
  const next = normalizeShellMode(mode);
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(SHELL_MODE_STORAGE_KEY, next);
    } catch {
      // ignore quota / private mode
    }
  }
  return next;
}
